export default __webpack_public_path__ + "static/media/BAN1.b040b277.webp";